var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-view-wrapper relative"},[_c('a-icon',{staticClass:"absolute text-danger",staticStyle:{"top":"4px","right":"4px"},attrs:{"type":"close","disabled":_vm.disabled}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }